/**
 * DevExtreme (esm/core/element.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export function getPublicElementNonJquery(element) {
    if (element && element.get) {
        return element.get(0)
    }
    return element
}
var strategy = getPublicElementNonJquery;
export function getPublicElement(element) {
    return strategy(element)
}
export function setPublicElementWrapper(newStrategy) {
    strategy = newStrategy
}
